import { Select, SelectItem } from '@mantine/core'
import { useEffect, useState } from 'react'
import { SelectProps } from '@mantine/core/lib/Select/Select'
import UserPosition from '@api/UserPosition'
interface IInputUserPosition
    extends Omit<SelectProps & React.RefAttributes<HTMLInputElement>, 'data'> {
    data?: readonly (string | SelectItem)[]
    withAll?: boolean
}

interface ItemProps extends SelectItem {}

const InputUserPosition = ({
    withAll = false,
    classNames,
    value,
    styles,
    unstyled,
    className,
    defaultValue,
    ...others
}: IInputUserPosition) => {
    const { data } = UserPosition.useGetAllUserPositions({})
    const [list, setlist] = useState<ItemProps[]>([])
    useEffect(() => {
        if (data) {
            const selectlists = data.lists.map((e) => {
                return {
                    value: String(e.user_position_id),
                    label: e.user_position_name,
                }
            })
            if (withAll) {
                selectlists.unshift({
                    value: '',
                    label: 'ทั้งหมด',
                })
            }
            setlist(selectlists)
        }
        // eslint-disable-next-line
    }, [data])

    return (
        <Select
            key={list.length}
            className={className}
            label='ตำแหน่ง'
            value={String(value)}
            placeholder='ตำแหน่ง'
            data={list}
            filter={(value, item: ItemProps) =>
                item.label!.toLowerCase().includes(value.toLowerCase().trim())
            }
            {...others}
        />
    )
}

export default InputUserPosition
